import React from 'react';
import ListView from '../../../../General/ListView/ListView';

const FormDefinitionSection = (props) => {

    let addButton;

    if (props.page.configureActions !== undefined && props.page.configureActions !== null) {
        if (props.page.configureActions.includes("add")) {
            addButton = props.addButton;
        }       
    }

    let listView = <ListView 
                        type={props.type}
                        parentId={props.parentId}
                        refresh={props.refresh}
                        columns={props.columns}
                        listData={props.page.fields}
                        menuItems={props.menuItems}
                        itemSelected={props.itemSelected}
                        selectedRecord={props.selectedRecord}
                        selectionChanged={props.selectionChanged}
                        basicModeButtonHandler={props.basicModeButtonHandler}
                        onClick={props.onClick}
                        isDataLoaded={true}
                        addButton={addButton}
                        basic={true}
                        displaySummary={true}>
                    </ListView>

    if (props.page.configureActions !== undefined && props.page.configureActions !== null) {
        if (props.page.configureActions.includes("nofields")) {
            listView = (null);
        }       
    }

    return (
        <div className='managerecord-section-table'>
            {listView}
        </div>
    )
}

export default FormDefinitionSection;